import { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { Select, SelectProps } from 'antd';

import { AssetCategoryToText } from '@/entities/assets';
import { AssetCategory } from '@/shared/lib/sj-orm/models/asset.dto';

export const SelectAssetCategory: FC<SelectProps> = (props) => {
  const { t } = useTranslation('assets');
  const { placeholder, options, ...componentProps } = props;

  const categoryOptions = useMemo(() => {
    const items = options
      ? options.map(({ value }) => ({
          value,
          label: t(AssetCategoryToText[value as AssetCategory]),
        }))
      : Object.entries(AssetCategoryToText).map(([key, value]) => {
          return { value: key, label: t(value) };
        });

    return { options: items };
  }, [t]);

  return (
    <Select
      placeholder={placeholder ?? 'Select Category'}
      options={categoryOptions.options}
      filterOption={(inputValue, option) =>
        Boolean(
          String(option?.label)
            .toLocaleLowerCase()
            .includes(inputValue.toLocaleLowerCase()),
        )
      }
      showSearch={true}
      {...componentProps}
    />
  );
};
